import { useCallback } from 'react';
import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { BlockContainer, FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import SummaryInfo from '~/src/features/tariffBuilder/components/SummaryInfo';
import { GA_CATEGORY } from '~/src/features/tariffBuilder/constants/analytics';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getSummaryInfo from '~/src/features/tariffBuilder/selectors/getSummaryInfo';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';
import { getAnalyticsSender } from '~/src/helpers/hooks/useAnaliticsSender';

import AgreementInfoContainer from '../AgreementInfoContainer';

const SummaryInfoContainer = (): JSX.Element | null => {
    const sendAnalytics = getAnalyticsSender(GA_CATEGORY);

    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const summaryInfo = useCtxSelector(getSummaryInfo);
    const { agreement, currentTariff } = useCtxSelector(state => ({
        agreement: state.agreement,
        currentTariff: selectCurrentTariff(state),
    }));
    const router = useRouter();

    const onGoToPayment = useCallback(() => {
        router.push({
            pathname:'/payments',
            query: {
                pay: 'online',
                agreement: agreement.agreementNumber,
                s: summaryInfo.total,
            },
        });

        sendAnalytics('click payment', 'btn: "Оплатить"');
    }, []);

    if (isLaptop) {
        return null;
    }

    return (
        <>
            <AgreementInfoContainer/>
            {!agreement.hasError && !currentTariff &&
                <H3>Оплатить можно только до&nbsp;или во&nbsp;время визита инженера</H3>
            }
            <WithSkeleton
                height={350}
                width={'100%'}
                inline
                containerClassName={'react-skeleton-flex-1 fd-row gap16'}
                style={{
                    position: 'sticky',
                    top: 120,
                    marginTop: 145,
                    padding: 24,
                }}
            >
                <BlockContainer
                    rounder={{
                        $radius: 24,
                    }}
                    indent={{
                        $united: [24],
                    }}
                >
                    <FullWidthListContainer $direction={'column'} $size={24} $wrap='nowrap'>
                        <SummaryInfo
                            {...summaryInfo}
                        />
                        {!agreement.hasError && !currentTariff &&
                            <Button onClick={onGoToPayment}>Оплатить</Button>
                        }
                    </FullWidthListContainer>
                </BlockContainer>
            </WithSkeleton>
        </>
    );
};

export default SummaryInfoContainer;
